import { EditorState, AtomicBlockUtils } from "draft-js";

/**
 * 插入一个显示导入文档进度的 block
 *
 * @param {DraftEditorStore} store
 * @param {string} name
 * @param {Draft.SelectionState} selection
 */
export function insertImportAtomic(store, name, type, selection) {
	const { getEditorState, setEditorState } = store;
	const editorState = getEditorState();
	const content = editorState.getCurrentContent();
	const contentWithEntity = content.createEntity('IMPORT', 'IMMUTABLE', { name, type });

	const entityKey = contentWithEntity.getLastCreatedEntityKey();

	const newEditorState = AtomicBlockUtils.insertAtomicBlock(
		EditorState.set(editorState, {
			currentContent: contentWithEntity,
			selection
		}),
		entityKey,
		`[${name}]`,
	);
	setEditorState(newEditorState);

	const block = newEditorState.getCurrentContent()
		.getBlockAfter(selection.getFocusKey());

	return { entityKey, block };
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/fileImportPlugin/modifier/insertImportAtomic.js